import { allowedTransactionTypes, orderTransactionTypes } from '../constants'

export const getRecoveryTransactionType = ({ transactionTypes, allowsUnifiedFlow }) => {
  if (allowsUnifiedFlow) return orderTransactionTypes.mixed

  const allowsRefund =
    transactionTypes.includes(allowedTransactionTypes.instantRefund) ||
    transactionTypes.includes(allowedTransactionTypes.originalPaymentMethod)

  return allowsRefund ? orderTransactionTypes.refund : orderTransactionTypes.exchange
}
